/* eslint-disable import/prefer-default-export */
import { fireLinkTag } from './tagManager';

/**
 * Event for see more/fewer sizes
 * @param {boolean} isOpen
 */
export function tagSizesSeeAll(isOpen) {
  const eventName = isOpen ? 'pdp see more size expand' : 'pdp see more size collapse';

  fireLinkTag({
    event_name: eventName,
  });
}

export function tagOnSizeDropdown() {
  const eventName = 'pdp size drop down';

  fireLinkTag({
    event_name: eventName,
  });
}
